import { useGetAllRoutes } from '@/hooks/data/masterDataHook';

import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {}
export default function RouteInput({ ...props }: Props) {
  const { data, isLoading } = useGetAllRoutes();

  return (
    <Select
      maxTagCount="responsive"
      allowClear
      placeholder={'Select route'}
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {c.name}
          </Select.Option>
        );
      })}
    </Select>
  );
}
